export default function trackHotjar(eventName: string) {
  if (window && typeof (window as any).hj !== 'undefined') {
    (window as any).hj('trigger', eventName);
  }
}
